"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimeBlock;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _density = require("@site/pattern-library-utils/density");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _text = _interopRequireDefault(require("@ux/text"));
const TimeBlockItem = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TimeBlockItem",
  class: "core-t1dhgrxs"
});
const TimeValue = /*#__PURE__*/(0, _react2.styled)(TimeBlockItem)({
  name: "TimeValue",
  class: "core-t1p0jsj9"
});

/**
* Render TimeBlock
*
* @param {object} props React props for TimeBlock element
* @param {string} props.dataCy data-cy attribute for time block
* @param {object} props.timeValue Time block's value
* @param {string} props.timeLabel Label for time block
* @returns {React.ReactElement} TimeBlock component
* @public
*/
function TimeBlock({
  dataCy,
  timeValue,
  timeLabel
}) {
  return /*#__PURE__*/_react.default.createElement(TimeBlockItem, {
    className: "time-block",
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(TimeValue, null, timeValue), timeLabel && /*#__PURE__*/_react.default.createElement(_text.default.span, {
    className: "time-label",
    "data-cy": "time-label"
  }, timeLabel));
}
TimeBlock.propTypes = {
  dataCy: _propTypes.default.string,
  timeValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  timeLabel: _propTypes.default.string.isRequired
};